export default {
	'account' : () => import('./Domains/account.js'),
	'awards' : () => import('./Domains/awards.js'),
	'black-friday' : () => import('./Domains/black-friday.js'),
	'boloes-detail' : () => import('./Domains/boloes-detail.js'),
	'boloes' : () => import('./Domains/boloes.js'),
	'cart' : () => import('./Domains/cart.js'),
	'desdobramentos-detail' : () => import('./Domains/desdobramentos-detail.js'),
	'fechamentos-detail' : () => import('./Domains/fechamentos-detail.js'),
	'game-techniques' : () => import('./Domains/game-techniques.js'),
	'home' : () => import('./Domains/home.js'),
	'institutional-atendimento' : () => import('./Domains/institutional-atendimento.js'),
	'institutional-como-funciona' : () => import('./Domains/institutional-como-funciona.js'),
	'institutional-dias-de-sorteio' : () => import('./Domains/institutional-dias-de-sorteio.js'),
	'institutional-jogo-responsavel' : () => import('./Domains/institutional-jogo-responsavel.js'),
	'institutional-metodos-de-pagamento' : () => import('./Domains/institutional-metodos-de-pagamento.js'),
	'institutional-politica-de-privacidade' : () => import('./Domains/institutional-politica-de-privacidade.js'),
	'institutional-promocao-mega-da-virada' : () => import('./Domains/institutional-promocao-mega-da-virada.js'),
	'institutional-quem-somos' : () => import('./Domains/institutional-quem-somos.js'),
	'institutional-termos-de-uso' : () => import('./Domains/institutional-termos-de-uso.js'),
	'login' : () => import('./Domains/login.js'),
	'lottery-boloes' : () => import('./Domains/lottery-boloes.js'),
	'lottery-como-apostar' : () => import('./Domains/lottery-como-apostar.js'),
	'lottery-custom' : () => import('./Domains/lottery-custom.js'),
	'lottery-detail' : () => import('./Domains/lottery-detail.js'),
	'lottery-featured' : () => import('./Domains/lottery-featured.js'),
	'lottery-odds' : () => import('./Domains/lottery-odds.js'),
	'lottery-statistics' : () => import('./Domains/lottery-statistics.js'),
	'lp-ebook-home' : () => import('./Domains/lp-ebook-home.js'),
	'lp-ebook' : () => import('./Domains/lp-ebook.js'),
	'monte-seu-jogo' : () => import('./Domains/monte-seu-jogo.js'),
	'news' : () => import('./Domains/news.js'),
	'page-404' : () => import('./Domains/page-404.js'),
	'payment-confirmation' : () => import('./Domains/payment-confirmation.js'),
	'recarga-celular-checkout' : () => import('./Domains/recarga-celular-checkout.js'),
	'recarga-celular-confirmation' : () => import('./Domains/recarga-celular-confirmation.js'),
	'recarga-celular' : () => import('./Domains/recarga-celular.js'),
	'results-detail' : () => import('./Domains/results-detail.js'),
	'statistics' : () => import('./Domains/statistics.js'),
	'table-award-como-apostar' : () => import('./Domains/table-award-como-apostar.js'),
	'tele-sena-checkout' : () => import('./Domains/tele-sena-checkout.js'),
	'tele-sena' : () => import('./Domains/tele-sena.js')
}